import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Ride type override enumeration.
 */
export const RideTypeOverrideSchema = z.enum(['', 'lyft', 'uber', 'shuttle']);

export type RideTypeOverride = z.infer<typeof RideTypeOverrideSchema>;

/**
 * Preferred rideshare partner override.
 */
export const schema = RideTypeOverrideSchema;

export const definition = define({
  key: 'ride_type_override',
  schema,
  label: 'Preferred Ride Partner',
  description:
    "Select the preferred rideshare service for clients at this level. When planning an 'auto' ride, this partner will be selected by default",
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.RIDESHARE.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.REGION, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: '',
});
